import type { PinScope } from '../api/chats';
import type { MessageDto } from '../api/types';

export interface PinnedEntry {
  msg: MessageDto;
  scope: PinScope;
  at: string;
}

/**
 * Объединяет "закреплено для всех" (pinnedShared) и "закреплено только у меня"
 * (pinnedPersonal) в один список, отсортированный по времени закрепления (новые сверху).
 * Используется и в баннере закреплённого над лентой (ChatView), и во вкладке закреплённых
 * инфопанели (ChatInfoModal) — оба показывают один и тот же набор закреплённых сообщений.
 */
export function mergePinnedMessages(pinnedShared: MessageDto[], pinnedPersonal: MessageDto[]): PinnedEntry[] {
  const shared = pinnedShared.map((m) => ({ msg: m, scope: 'all' as const, at: m.pinnedAt ?? '' }));
  const personal = pinnedPersonal.map((m) => ({ msg: m, scope: 'me' as const, at: m.personalPinnedAt ?? '' }));
  // Дедуп по msg.id — если сообщение когда-либо окажется закреплено и "для всех", и "только у
  // меня" одновременно, оставляем одно вхождение (shared приоритетнее), иначе React-key по id
  // задублировался бы у потребителей списка (ChatView/ChatInfoModal).
  const seen = new Set<number>();
  const merged: PinnedEntry[] = [];
  for (const entry of [...shared, ...personal]) {
    if (seen.has(entry.msg.id)) continue;
    seen.add(entry.msg.id);
    merged.push(entry);
  }
  return merged.sort((a, b) => (a.at < b.at ? 1 : -1));
}
